<template>
<form @keyup.enter="save">
  <div>
    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label  field-required">Name</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'" :class="{'is-danger': errors.has('name') }" name="name" v-model="body.name" class="input" type="text" placeholder="Enter area name">
          <span v-show="errors.has('name')" class="help is-danger">{{ errors.first('name') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label  field-required">Description</label>
      </div>
      <div class="control is-grouped">
        <p class="control is-expanded">
          <input v-validate="'required|max:255'" :class="{'is-danger': errors.has('description') }" name="description" v-model="body.description" class="input" type="text" placeholder="Enter area description">
          <span v-show="errors.has('description')" class="help is-danger">{{ errors.first('description') }}</span>
        </p>
      </div>
    </div>

    <div class="control is-horizontal">
      <div class="control-label">
        <label class="label"></label>
      </div>
      <div class="control">
        <a @click="cancel" class="button is-link">Cancel</a>
        <save-button :loading="isSaving" @click="save"/>
      </div>
    </div>
  </div>
</form> 
</template>

<script>
  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {}
        }
      },
      isSaving: Boolean
    },
    data() {
      return {
        body: {
          name: this.data.name ? this.data.name : '',
          description: this.data.description ? this.data.description : ''
        }
      }
    },
    methods: {
      cancel() {
        this.$emit('cancel');
      },
      save() {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.$emit('save', this.body);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>